// extracted by mini-css-extract-plugin
export default {"container":"col_S3mt1","image":"col_ima_2LEBS","description":"col_des_NaLRX"};